import { Action, Module, VuexModule } from "vuex-module-decorators";
import { CounterLog } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class CounterLogModule extends VuexModule {
    @Action
    [CounterLog.getCounterLogList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/log/counters/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [CounterLog.findPageCounterLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/counters`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [CounterLog.saveCounterLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/counters/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [CounterLog.deleteCounterLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/counters/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}